import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, logout } = useAuth();
  const [queueData, setQueueData] = useState<any>(null);

  useEffect(() => {
    fetchQueueStatus();
    const interval = setInterval(() => {
      fetchQueueStatus();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const fetchQueueStatus = async () => {
    try {
      const response = await axios.get(`${API_BASE}/queue`);
      setQueueData(response.data);
    } catch (error) {
      console.error('Failed to fetch queue status:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-8">
              <a href="/" className="cursor-pointer">
                <img
                  src="/logo.png"
                  alt="Architect Dock"
                  className="h-8 w-auto hover:opacity-80 transition-opacity"
                />
              </a>
              <div className="hidden md:flex space-x-6">
                <a href="/" className="text-gray-600 hover:text-blue-600 font-medium transition-colors">
                  Generate
                </a>
                <a href="/history" className="text-gray-600 hover:text-blue-600 font-medium transition-colors">
                  History
                </a>
                <a href="/gallery" className="text-gray-600 hover:text-blue-600 font-medium transition-colors">
                  Gallery
                </a>
                {(user?.role === 'super_admin' || user?.role === 'admin') && (
                  <a href="/admin" className="text-gray-600 hover:text-blue-600 font-medium transition-colors">
                    Admin
                  </a>
                )}
              </div>
            </div>
            <div className="flex items-center space-x-4">
              {/* Compact Queue Status */}
              {queueData && (
                <a
                  href="/queue"
                  className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-lg px-3 py-1.5 hover:bg-blue-100 transition-colors"
                  title="View Queue"
                >
                  <div className="flex items-center gap-1.5">
                    <span className="text-xs font-medium text-blue-700">Jobs:</span>
                    <span className="text-sm font-bold text-blue-600">
                      {(queueData?.stats?.processing || 0) + (queueData?.stats?.queued || 0) + (queueData?.stats?.submitting || 0)}
                    </span>
                  </div>
                  <div className="h-4 w-px bg-blue-300"></div>
                  <div className="flex items-center gap-1.5">
                    <span className="text-xs font-medium text-blue-700">Items:</span>
                    <span className="text-sm font-bold text-blue-600">
                      {queueData?.stats?.total_items || 0}
                    </span>
                  </div>
                </a>
              )}
              <span className="text-sm text-gray-600">
                Welcome, {user?.username}
              </span>
              <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium">
                {user?.role}
              </span>
              <button
                onClick={logout}
                className="text-gray-500 hover:text-gray-700 text-sm border border-gray-300 px-3 py-1 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>
      <main className="max-w-7xl mx-auto py-6 px-4">
        <div className="bg-white rounded-2xl shadow-xl p-6 min-h-[calc(100vh-136px)]">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
